import React from 'react';
import styled from 'styled-components';

import BrandedBanner from './branded-banner';
import BrandedContentRows from './branded-content-rows';
import BrandedCTA from './branded-cta';
import BrandedStyles from './branded-styles';
import BrandedImageSlider from './branded-image-slider';
import BrandedTable from './branded-table';
import BrandedBlogWave from './branded-blog-wave';
import BrandedForm from './branded-form';
import SEO from '../../seo';

const BrandedLandingPageContainer = styled.div``;

const BrandedLandingPage = ({ page }) => {
    // console.log('page', page);
    const {
        brandedBannerSettings,
        brandedContentRows,
        brandedLpCta,
        brandedStyles,
        brandedImageSliderSettings,
        brandedTableSettings,
        brandedFooterHeadline,
        brandedFooterButton,
        brandedBlogHandle,
    } = page.branded_lp_acf || {};
    return (
        <BrandedLandingPageContainer>
            <SEO title={page.title} />
            {brandedBannerSettings && (
                <BrandedBanner content={brandedBannerSettings} />
            )}
            {brandedContentRows && (
                <BrandedContentRows rows={brandedContentRows} />
            )}
            {brandedLpCta && <BrandedCTA content={brandedLpCta} />}
            {brandedStyles && <BrandedStyles content={brandedStyles} />}
            {brandedImageSliderSettings && (
                <BrandedImageSlider content={brandedImageSliderSettings} />
            )}
            {brandedTableSettings && (
                <BrandedTable content={brandedTableSettings} />
            )}
            <BrandedForm />
            {brandedFooterHeadline && brandedFooterButton && (
                <BrandedBlogWave
                    waveTitle={brandedFooterHeadline}
                    waveButton={brandedFooterButton}
                    handle={brandedBlogHandle}
                />
            )}
        </BrandedLandingPageContainer>
    );
};

export default BrandedLandingPage;
